import * as React from "react";
import { Typography, Button } from "antd";
import SelectInput from "../app/SelectInput";
import { IReportingPeriodItem } from "../../../model/report/ReportingPeriodItem";

const Report5ParamBox = ({
  currentReportingPeriod,
  reportingPeriodList,
  onChangeReportingPeriod,
  getPDFReport,
  translate,
  loading,
  title
}: {
  currentReportingPeriod?: IReportingPeriodItem;
  reportingPeriodList: IReportingPeriodItem[];
  onChangeReportingPeriod(reportingPeriodId: number): void;
  getPDFReport: any;
  translate: any;
  loading?: boolean;
  title?: string;
}) => {
  return (
    <div className={"report-sidebar"}>
      <div className={"report-param-title "}>
        <Typography.Title style={{ fontSize: 14, marginBottom: 10 }}>
          {title}
        </Typography.Title>
        <SelectInput
          value={currentReportingPeriod?.id.toString()}
          placeholder={translate("reports.params.placeholder")}
          selectOptions={reportingPeriodList}
          selectOptionKey={"id"}
          selectOptionValue={"name"}
          style={{ width: "100%" }}
          onChange={(e) => onChangeReportingPeriod(parseInt(e, 10))}
          defaultActiveFirstOption={false}
          showSearch={true}
          notFoundContent={translate("search.no_data")}
        />
      </div>

      <Button
        className={"report-btn"}
        type="primary"
        onClick={getPDFReport}
        loading={loading || false}
        disabled={currentReportingPeriod ? false : true}
      >
        {translate("reports.show")}
      </Button>
    </div>
  );
};

export default Report5ParamBox;
